import { render, staticRenderFns } from "./CustomerSchedule.vue?vue&type=template&id=38720570&scoped=true"
import script from "./CustomerSchedule.vue?vue&type=script&lang=js"
export * from "./CustomerSchedule.vue?vue&type=script&lang=js"
import style0 from "./CustomerSchedule.vue?vue&type=style&index=0&id=38720570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38720570",
  null
  
)

export default component.exports